/**
 * Shared donut/pie slice palette — the TaskMagix sidebar / brand colour
 * system (index.css :root). Brand chart tones first (Deep Navy → Bright
 * Cyan → Ocean → Sky Cyan), then the sidebar-gradient navies. Every
 * CATEGORICAL donut across all panels assigns slice colours from this by
 * index (`DONUT_PALETTE[i % DONUT_PALETTE.length]`) so they read as one
 * family. (Status / priority donuts keep their own semantic colours.)
 *
 * Kept in its own module (not Charts.jsx) so the chart file only exports
 * components — otherwise React Fast Refresh / HMR breaks for it.
 */
export const DONUT_PALETTE = [
  '#02367B', // Deep Navy
  '#04BADE', // Bright Cyan
  '#006CA5', // Ocean
  '#0496C7', // Sky Cyan
  '#0a2349', // sidebar mid-navy
  '#0d2c5c', // sidebar bottom-navy
]

/** Task Health colours — the To Do / Completed / Overdue split shown by the
 *  Company Admin Non-repeat / Repeat Task Completion 3D pies and the Sub
 *  Admin "Task Health" donut. One source so the dashboards always match. */
export const TASK_HEALTH_COLORS = Object.freeze({
  onTrack: '#0496C7',
  overdue: '#E11D48',
  completed: '#059669',
})
